<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(back='page6-17')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero elegir la mejor condición para contratar mi Crédito Hipotecario!
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B') PREGUNTA
            v-card-text.titulo24Reg.text-center
              | ¿Con qué plan crees que disfrutará más su retiro?
            v-card.questionCard(justify-center, flat)
              v-card-text.titulo18Book.text-center
                | Marca la respuesta correcta:
              v-radio-group(v-model='respuesta')
                v-layout.ml-5(v-for='(reactivo, index) in reactivos', :key='index')
                  v-flex.iconos.text-xs-center.pt-3(xs1, align-center, align-content-center)
                    div(v-if='sent && (correcta == index || respuesta == index)')
                      v-icon(size='15px', color='green', v-if='sent && (correcta == index)') fas fa-check
                      v-icon(size='15px', color='red', v-if='sent && (correcta != index)') fas fa-times
                  v-flex.iconos.text-xs-right(xs1, align-content-center)
                    v-radio(hide-details, :value='index')
                  v-flex.label16tt_blue.text-xs-left.pr-5(xs12, align-content-center)
                    div(style="display:inline;").mx-2.pr-5.parrafoDestacadoB(v-html="reactivo.descripcion")
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false')
                  v-btn.btn(color='secondary', v-bind:class='responseIsNone', :disabled="respuesta=='none'", @click='sendResult()')
                    | Enviar
                div(v-if='sent')
                  v-btn.btn(color='accent', style='z-index:2', @click.prevent='dialog=true')
                    | Ver Retroalimentación
                  v-dialog(v-model='dialog', persistent, max-width='930px')
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          .pt-1.pr-2(v-if='sent && (respuesta==correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Bien!
                          .pt-1.pr-2(v-if='sent && (respuesta!=correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoStop.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | Hay una mejor respuesta...
                          v-card.px-5.questionCard(justify-center, flat)
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==0)')
                              v-card-text.dialog_text
                                | Es una buena idea, pero se tendría que limitar a la ganancia que obtuvo de la venta y además, tendría que mudarse a las afueras de la ciudad.
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==1)')
                              v-card-text.dialog_text
                                b ¡Excelente consejo! 
                                .pt-3  ¡Esta opción le permitirá tener dos casas de acuerdo a sus necesidades y metas de retiro! Además, disfrutará de una mayor calidad de vida al tener un lugar dónde descansar.
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==2)')
                              v-card-text.dialog_text
                                | Sin aprovechar la ganancia que puede obtener de la venta de su casa actual, pedir un Crédito Hipotecario significa adquirir una deuda mucho más alta y duradera.
                          v-btn.btn.dialog_btn(color='accent', @click.prevent="nextPage('page6-19')")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      reactivos: [{
          descripcion: 'Un Crédito Hipotecario no es necesario. La mejor opción es que venda su casa actual para comprar dos pequeñas fuera de la ciudad, donde los precios son más accesibles.',
        },
        {
          descripcion: 'Puede vender la casa donde vive actualmente para comprar un lugar de descanso fuera de la ciudad (donde las propiedades son más baratas) y lo puede rentar mientras no lo ocupa. <br> Puede solicitar un Crédito Hipotecario por un monto menor y sumarlo al remanente de la venta para adquirir un departamento más pequeño en la ciudad.',
        },
        {
          descripcion: 'Puede solicitar un Crédito Hipotecario para una segunda propiedad fuera de la ciudad y rentarla para pagar la mensualidad del crédito. ',
        }
      ],
      selected: [],
      respuesta: 'none',
      response: 0,
      correcta: 1,
      sent: false,
      feedback: false,
      dialog: false
    }
  },
  methods: {
    sendResult() {
      if (this.respuesta == this.correcta) {
        this.response = 1;
      }
      this.sent = true;
      eventBus.$emit('send_result', this.response);
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  },
  computed: {
    responseIsNone() {
      return {
        'btn-primary': this.respuesta != 'none',
        'btn-secondary': this.respuesta == 'none'
      }
    },
    checkResult() {
      return {
        'done': this.response != 'none',
        'clear': this.response == 'none'
      }
    }
  }
};
</script>
